// src/pages/user/Dashboard.js
import React from "react";
import ShortenForm from "../../components/ShortenForm";
import LinkList from "../../components/LinkList";
import { Box, Paper, Typography, Grid } from "@mui/material";

export default function Dashboard() {
  return (
    <Box>
      {/* Thông báo nâng cấp tài khoản */}
      <Paper sx={{ bgcolor: "#fde9e9", p: 2, mb: 3, color: "#b91c1c", fontWeight: 700, borderRadius: 2 }}>
        hãy rút gọn và quản lý link  theo phong cách của bạn
      </Paper>
      {/* Form rút gọn link */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <ShortenForm token={localStorage.getItem('token')} />
      </Paper>
      {/* Thống kê (demo số lượng, có thể custom) */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={12} md={2}>
          <Paper sx={{ p: 2, textAlign: "center" }}>
            <Typography variant="subtitle2">Liên kết</Typography>
            <Typography variant="h4">0</Typography>
            <Typography variant="caption" color="success.main">+0 Hôm nay</Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} md={2}>
          <Paper sx={{ p: 2, textAlign: "center" }}>
            <Typography variant="subtitle2">Click</Typography>
            <Typography variant="h4">0</Typography>
            <Typography variant="caption" color="success.main">+0 Hôm nay</Typography>
          </Paper>
        </Grid>
        {/* Có thể bổ sung thêm widget */}
      </Grid>
      {/* Danh sách link gần đây */}
      <Paper sx={{ p: 2 }}>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>Liên kết gần đây</Typography>
        <LinkList token={localStorage.getItem('token')} />
      </Paper>
    </Box>
  );
}
